import {Component} from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-footer',
    templateUrl: './app.footer.component.html'
})
export class AppFooterComponent {

    anno = new Date().getFullYear();

    constructor(public layoutService: LayoutService) {}
}
